import { cn } from '@/lib/utils';

interface Props {
  total: number | string;
  delivered: number | string;
  failed: number | string;
  abandoned: number | string;
  className?: string;
}

/**
 * Dense inline indicator that shows e.g. `2/3 ✓ · 1 ✕` for a webhook event's
 * fan-out across N endpoints. Designed for table cells, not for the detail
 * panel.
 */
export function DeliverySummaryPips({
  total,
  delivered,
  failed,
  abandoned,
  className,
}: Props) {
  const t = Number(total);
  const d = Number(delivered);
  const f = Number(failed);
  const a = Number(abandoned);

  if (t === 0) {
    return (
      <span className={cn('text-xs text-muted-foreground', className)} aria-label="No deliveries">
        —
      </span>
    );
  }

  return (
    <span
      className={cn('flex flex-wrap items-center gap-x-2 text-xs tabular-nums', className)}
      aria-label={`${d} delivered, ${f} failed, ${a} abandoned out of ${t}`}
    >
      <span className="text-emerald-600 dark:text-emerald-400">
        {d}/{t} <span aria-hidden>✓</span>
      </span>
      {f > 0 && (
        <span className="text-amber-600 dark:text-amber-400">
          <span className="text-muted-foreground">·</span> {f} <span aria-hidden>↻</span>
        </span>
      )}
      {a > 0 && (
        <span className="text-rose-600 dark:text-rose-400">
          <span className="text-muted-foreground">·</span> {a} <span aria-hidden>✕</span>
        </span>
      )}
    </span>
  );
}
